// @flow

import ReprintMessage from './ReprintMessage'

export default ReprintMessage
